import { useParams } from 'react-router-dom'

export const useConversationUuid = (uuidToUse?: string) => {
  const { uuid } = useParams<{ uuid: string; workspaceUuid: string }>()
  const currentUuid = uuid || ''

  return uuidToUse || currentUuid
}

export const useWorkspaceUuid = () => {
  const { workspaceUuid } = useParams<{ workspaceUuid: string }>()
  return workspaceUuid
}
